import styled from "@emotion/styled";
import {
  WHITE,
  LIGHT_BLUE,
  GREY,
  APP_TEMA,
  BEI_JYO,
  RED,
} from "../../styles/color";

export const MainLayout2 = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  border-radius: 10px;
  width: 100%;
  text-align: center;
  padding-bottom: 100px;
`;

export const MainBody = styled.div`
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

export const Title = styled.h2`
  margin-left: 20px;
  margin-right: 20px;
  color: ${LIGHT_BLUE};
  text-align: left;
  margin-bottom: 20px;
`;

export const StyledCard = styled.div`
  background-color: ${WHITE};
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  background-color: ${APP_TEMA};
  color: ${WHITE};
  padding: 12px 15px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 576px) {
    font-size: 14px;
    padding: 10px 12px;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
`;

export const CardBody = styled.div`
  padding: 15px;
  background-color: ${BEI_JYO};
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  background-color: ${BEI_JYO};
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: ${BEI_JYO};
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 12px;
  }

  th {
    background-color: ${APP_TEMA};
    color: ${WHITE};
    padding: 10px 8px;
    text-align: left;
    white-space: nowrap;
    border-bottom: 2px solid ${GREY};
  }

  td {
    padding: 8px;
    border-bottom: 1px solid ${GREY};
    vertical-align: middle;
  }

  tr:nth-of-type(even) {
    background-color: ${WHITE};
  }

  tr:hover {
    background-color: #e8f4ff;
  }
`;

export const SmallButton = styled.button`
  padding: 6px 12px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  background-color: ${(props) =>
    props.variant === "danger"
      ? RED
      : props.variant === "success"
        ? "#28a745"
        : props.variant === "dark"
          ? "#343a40"
          : LIGHT_BLUE};
  color: ${WHITE};

  &:hover {
    opacity: 0.85;
  }

  &:disabled {
    background-color: ${GREY};
    cursor: not-allowed;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background: ${WHITE};
  padding: 20px;
  border-radius: 8px;
  max-width: 940px;
  width: 95%;
  max-height: 92vh;
  overflow-y: auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: ${APP_TEMA};
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: bold;
  color: #444;
  margin-bottom: 4px;
`;

export const FormControl = styled.input`
  width: 100%;
  padding: 7px 9px;
  font-size: 13px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${LIGHT_BLUE};
    box-shadow: 0 0 0 2px rgba(0, 149, 255, 0.2);
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 7px 9px;
  font-size: 13px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  box-sizing: border-box;
  resize: vertical;
  min-height: 70px;
  font-family: "Courier New", Courier, monospace;

  &:focus {
    outline: none;
    border-color: ${LIGHT_BLUE};
    box-shadow: 0 0 0 2px rgba(0, 149, 255, 0.2);
  }
`;

export const FieldHint = styled.span`
  font-size: 11px;
  color: ${GREY};
  margin-top: 2px;
`;

export const ToolbarRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 15px;

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;

  @media (max-width: 576px) {
    flex-direction: column;
    button {
      width: 100%;
    }
  }
`;

export const PreviewImage = styled.div`
  margin-top: 6px;
  max-width: 260px;
  max-height: 90px;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid ${GREY};

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const TextMuted = styled.span`
  color: ${GREY};
  font-size: 13px;
`;